"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SkipTo = require("./components/SkipTo");
Object.keys(_SkipTo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkipTo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkipTo[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./constants/defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
